import React from 'react';
import { Link, useSearchParams } from 'react-router-dom';
import { motion } from 'framer-motion';
import { XCircle, ArrowRight, RefreshCw } from 'lucide-react';
import { Button } from '../components/ui/button';

const PaymentFailed = () => {
  const [searchParams] = useSearchParams();
  const paymentId = searchParams.get('payment_id');

  return (
    <div className="py-16 md:py-24 min-h-[70vh] flex items-center">
      <div className="container mx-auto px-4 md:px-6 max-w-xl">
        <motion.div
          initial={{ opacity: 0, scale: 0.95 }}
          animate={{ opacity: 1, scale: 1 }}
          className="glass-card p-8 md:p-12 text-center"
        >
          <div className="w-20 h-20 rounded-full bg-red-500/20 flex items-center justify-center mx-auto mb-6">
            <XCircle className="w-10 h-10 text-red-400" />
          </div>
          
          <h1 className="font-outfit text-3xl font-bold text-white mb-4" data-testid="payment-failed-title">
            Payment Not Completed
          </h1>
          
          <p className="text-slate-400 mb-8">
            Your payment was not completed. This could be due to:
          </p>
          
          <ul className="text-slate-400 text-left mb-8 space-y-2 max-w-sm mx-auto">
            <li className="flex items-start gap-2">
              <span className="text-red-400">•</span>
              <span>Payment was cancelled</span>
            </li>
            <li className="flex items-start gap-2">
              <span className="text-red-400">•</span>
              <span>Insufficient funds</span>
            </li>
            <li className="flex items-start gap-2">
              <span className="text-red-400">•</span>
              <span>Card declined by bank</span>
            </li>
            <li className="flex items-start gap-2">
              <span className="text-red-400">•</span>
              <span>Session expired</span>
            </li>
          </ul>

          <p className="text-slate-400 mb-8">
            Don't worry! You can try again or choose a different payment method.
          </p>

          <div className="flex flex-col sm:flex-row gap-4 justify-center">
            <Link to="/payment" className="btn-primary flex items-center justify-center gap-2">
              <RefreshCw className="w-4 h-4" /> Try Again
            </Link>
            <Link to="/contact" className="btn-secondary flex items-center justify-center gap-2">
              Contact Support <ArrowRight className="w-4 h-4" />
            </Link>
          </div>

          {paymentId && (
            <p className="text-slate-500 text-xs mt-8">
              Reference: {paymentId}
            </p>
          )}
        </motion.div>
      </div>
    </div>
  );
};

export default PaymentFailed;
